import React, { FC, useState } from 'react';
import './App.css';
import { Option } from './Option';
import styled from 'styled-components';
import { Settings } from './Settings';
import {winner} from './Winner'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import TwitterIcon from '@mui/icons-material/Twitter';

interface Props {
  spin?: boolean,
  active?: boolean,
  openMenu?: boolean
}
interface Prop2 {
  degrees: number,
  random: number
}

const App: FC = () => {
  const [random, setRandom] = useState<number>(0)
  const [degrees, setDegrees] = useState<number>(0)
  const [spin, setSpin] = useState<boolean>(false)
  const [active, setActive] = useState<boolean>(false)
  const [openMenu, setOpenMenu] = useState<boolean>(false)
  const [result, setResult] = useState<string>("")
  const spinSound = new Audio(require('./images/spinWheel.mp3').default)
  const vol = localStorage.getItem("volume")
  const [volume, setVolume] = useState<number>(Number(vol) || 0.5)
  const options = JSON.parse(localStorage.getItem("options") || '{}')
  const [val, setVal] = useState({
    val1: options.val1 || "code",
    val2: options.val2 || "drink water",
    val3: options.val3 || "do 10 squats",
    val4: options.val4 || "take a break",
    val5: options.val5 || "go outside",
  })
  const arr = new Array(24).fill("")
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setVal({
      ...val,
      [e.target.name]: e.target.value
    })
    localStorage.setItem("options", JSON.stringify(val))
  }
  const handlePull = () => {
    setRandom(getRandom(2160, 2520))
  }

  const handleRelease = () => {
    setSpin(true)
    setActive(false)
    spinSound.play()
    spinSound.volume = volume
    setTimeout(() => {
      setSpin(false)
      setDegrees(degrees + random)
      setResult(checkWinner((degrees + random) % 360))
      setRandom(0)
    }, 16000);
  
  }
  
  function getRandom(min: number, max: number) {
    return Math.floor(Math.random() * (max - min) + min);
  }

  function checkWinner(num: number) {
    for (let i = 0; i < winner.length; i++) {
      for (let j = 0; j < winner[i].length; j++) {
        if (num > winner[i][j][0] && num < winner[i][j][1]) {
          return i === 0 ? val.val1 :
                i === 1 ? val.val2 :
                i === 2 ? val.val3 :
                i === 3 ? val.val4 :
                val.val5
        }
      }
    }
  }


  return (
    <Container>
      <WheelContainer>
        <Arrow></Arrow>
        <Wheel degrees={degrees} random={random} className={spin ? "spin" : ""}>
          {arr.map((a, i) => (
            <Option key={i} index={i} 
              val={i % 2 ? val.val1 : 
                i % 4 ? val.val2 : 
                (i % 4 === 0 && i % 8 !== 0) ? val.val3 : 
                (i % 8 === 0 && i !== 0 && i % 24 !== 0) ? val.val4 : 
                i === 0 ? val.val5 : 
                ""}
              color={i % 2 ? "khaki" : 
                i % 4 ? "mediumseagreen" : 
                (i % 4 === 0 && i % 8 !== 0) ? "cornflowerblue" : 
                (i % 8 === 0 && i !== 0 && i % 24 !== 0) ? "mediumorchid" : 
                i === 0 ? "coral" : 
                ""}
            />
          ))}
        </Wheel>
        <LeverContainer spin={spin} onMouseDown={() => {setActive(true);handlePull()}} onMouseUp={handleRelease}>
          <Lever active={active}>
            <Handle spin={spin}></Handle>
            <Tube spin={spin}></Tube>
          </Lever>
        </LeverContainer>
      </WheelContainer>

      <Wrapper openMenu={openMenu}>
        <span>Common</span>
        <Input type="text" disabled={spin} maxLength={13} value={val.val1} spellCheck={false} onChange={handleChange} name="val1"/>
        <span>Uncommon</span>
        <Input type="text" disabled={spin} maxLength={13} value={val.val2} spellCheck={false} onChange={handleChange} name="val2"/>
        <span>Rare</span>
        <Input type="text" disabled={spin} maxLength={13} value={val.val3} spellCheck={false} onChange={handleChange} name="val3"/>
        <span>Epic</span>
        <Input type="text" disabled={spin} maxLength={13} value={val.val4} spellCheck={false} onChange={handleChange} name="val4"/>
        <span>Legendary</span>
        <Input type="text" disabled={spin} maxLength={13} value={val.val5} spellCheck={false} onChange={handleChange} name="val5"/>
        <KeyboardArrowDownIcon onClick={() => setOpenMenu(!openMenu)}/>
      </Wrapper>
      <Settings volume={volume} setVolume={setVolume} spin={spin} openMenu={openMenu}/>

      <Board><p className={!spin ? "textAnim" : ""}>{result}</p></Board>
      <Link href="https://twitter.com/codmitu" target="_blank">
        <TwitterIcon/> @codmitu
      </Link>
    </Container>
  );
}

export default App;


const Container = styled.div`
  display: grid;
  place-content: center;
  height: 100vh;
  overflow: hidden;
  position: relative;
`
const WheelContainer = styled.div`
  position: relative;
  z-index: 1;
  width: 66vh;
  height: 66vh;
  @media screen and (max-width: 800px) {
    transform: scale(0.8);
  }
  @media screen and (max-width: 617px) {
    transform: scale(0.6);
  }
`
const Arrow = styled.div`
  position: absolute;
  z-index: 12;
  width: 7%;
  height: 7%;
  top: -1vh;
  left: 50%;
  transform: translate(-50%, -50%);
  clip-path: polygon(0% 0%, 100% 0, 100% 50%, 50% 100%, 0 50%);
  background-image: linear-gradient(to bottom,  cyan, blue);
`
const Wheel = styled.div<Prop2>`
  transform:  rotate(${props => props.degrees}deg);
  background-image: radial-gradient(darkgray 0.5vh, cyan 1vh, green 2vh, darkgray 2vh);
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 1vh solid darkgray;
  outline-offset: -1vh;
  outline: 1.2vh dotted red;
  &.spin {
    animation: spinning 15.5s forwards ease;
    @keyframes spinning {
      7% {
        transform: rotate(${props => props.degrees - 15}deg);
      }
      100% {
        transform: rotate(${props => props.degrees + props.random}deg);
      }
    }
  }
  @keyframes bording {
    0% {
      outline: 1.2vh dotted red;
    }
    20% {
      outline: 1.2vh dotted blue;
    }
    40% {
      outline: 1.2vh dotted green;
    }
    60% {
      outline: 1.2vh dotted purple;
    }
    80% {
      outline: 1.2vh dotted orange;
    }
    100% {
      outline: 1.2vh dotted yellow;
    }
  }
`
const LeverContainer = styled.div<Props>`
  position: absolute;
  width: 10vh;
  height: 10vh;
  z-index: -1;
  top: 50%;
  right: -20%;
  transform: translate(-50%, -50%);
  pointer-events: ${props => props.spin ? "none" : "all"};
`
const Lever = styled.div<Props>`
  width: 100%;
  height: 100%;
  transition: all ${props => props.active ? 0.2 : 0.5}s linear;
  transform: rotate(${props => props.active ? 20 : 0}deg) translateY(${props => props.active ? 7 : 0}vh);
`
const Handle = styled.div<Props>`
  width: 30%;
  height: 30%;
  cursor: ${props => props.spin ? "not-allowed" : "pointer"};
  border-radius: 50%;
  position: absolute;
  top: 0;
  right: 0;
  background-image: ${props => props.spin ? 
                "radial-gradient(farthest-corner at 10px 10px, white, black)" : 
                "radial-gradient(farthest-corner at 10px 10px, #01da01, black)"};
  `
const Tube = styled.div<Props>`
  cursor: ${props => props.spin ? "not-allowed" : "pointer"};
  width: 5%;
  transform: rotate(45deg);
  transform-origin: bottom center;
  height: 110%;
  position: absolute;
  z-index: -1;
  bottom: 0;
  left: 0;
  background-image: linear-gradient(to right, white, #310000);
`
const Wrapper = styled.div<Props>`
  display: flex;
  flex-direction: column;
  width: 200px;
  max-width: 50vw;
  position: absolute;
  background-color: #ffffffc8;
  padding: 20px 0;
  z-index: 2;
  transition: transform .2s linear;
  transform: translateY(${props => props.openMenu ? 0 : -93}%);
  >span {
    font-weight: bold;
    margin-left: 10px;
  }
  >svg {
    margin: 0 auto -20px;
    cursor: pointer;
    font-size: 2rem;
    transform: rotate(${props => props.openMenu ? 180 : 0}deg);
    &:hover {
      color: #3b3b3b;
    }
  }
`
const Input = styled.input`
  margin: 10px 20px;
  padding: 5px 10px;
  font-size: 1.2rem;
  color: white;
  &:nth-child(2) {
    background-color: #d3c96bc7;
    outline: none;
    border: 3px solid khaki;
    border-radius: 10px;
  }
  &:nth-child(4) {
    background-color: #3cb372b9;
    outline: none;
    border: 3px solid mediumseagreen;
    border-radius: 10px;
  }
  &:nth-child(6) {
    background-color: #6494edba;
    outline: none;
    border: 3px solid cornflowerblue;
    border-radius: 10px;
  }
  &:nth-child(8) {
    background-color: #ba55d3cf;
    outline: none;
    border: 3px solid mediumorchid;
    border-radius: 10px;
  }
  &:nth-child(10) {
    background-color: #ff7f50be;
    outline: none;
    border: 3px solid coral;
    border-radius: 10px;
  }
`
const Board = styled.div`
  height: 10vh;
  width: 30vh;
  position: absolute;
  background-color: #ffffff;
  border-radius: 0% 20px;
  bottom: 0;
  margin: 0 auto;
  display: grid;
  place-content: center;
  font-family: Georgia, 'Times New Roman', Times, serif;
  font-size: 3vh;
  box-shadow: inset 0 0 10px 0px black;
  border: 5px solid #303030;
  >p {
    &.textAnim {
      animation: texting 0.5s ease-in;
      @keyframes texting {
        50% {
          font-size: 5vh;
          color: cyan;
        }
        100% {
          font-size: 3vh;
          color: black;
        }
      }
    }
  }
`
const Link = styled.a`
  position: absolute;
  bottom: 0;
  right: 0;
  /* color: lightgray; */
  text-decoration: none;
  color: #1d9bf0;
  font-size: 0.7rem;
  margin: 5px;
  >svg {
    font-size: 0.9rem;
    margin-bottom: -3px;
  }
`